var _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 82,
    viewBox: "0 0 88 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 67.0003,
    cy: 21.0003,
    r: 20.6718,
    fill: "url(#paint0_linear_5_2856)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5114 18.7717C70.3279 22.3368 70.3279 27.004 70.3279 36.3382V45.3343C70.3279 46.2664 70.3279 46.7325 70.3093 47.1263C69.9028 55.7115 63.0346 62.5797 54.4494 62.9862C54.0555 63.0048 53.5356 63.0048 52.4958 63.0048L52.229 63.0052C48.8281 63.0269 45.5154 64.0886 42.7354 66.0475L42.5586 66.1734L33.8562 72.3894C30.8729 74.5203 26.9527 71.4429 28.3142 68.039C29.2787 65.6278 27.5029 63.0048 24.906 63.0048H22.9001C15.9567 63.0048 10.3279 57.3761 10.3279 50.4326V36.3382C10.3279 27.004 10.3279 22.3368 12.1445 18.7717C13.7424 15.6356 16.292 13.0859 19.4281 11.4881C22.9933 9.67149 27.6604 9.67149 36.9946 9.67149H43.6612C52.9955 9.67149 57.6626 9.67149 61.2278 11.4881C64.3638 13.0859 66.9135 15.6356 68.5114 18.7717Z",
    fill: "#789EFF",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8279 36.3382V36.3145C70.8279 31.6674 70.8279 28.1503 70.5992 25.3508C70.3696 22.5407 69.907 20.4095 68.9569 18.5447C67.311 15.3145 64.6849 12.6884 61.4547 11.0425C59.5899 10.0924 57.4587 9.62982 54.6486 9.40022C51.8491 9.17149 48.332 9.17149 43.6849 9.17149H43.6612H36.9946H36.9709C32.3238 9.17149 28.8068 9.17149 26.0072 9.40022C23.1971 9.62982 21.0659 10.0924 19.2011 11.0425C15.971 12.6884 13.3448 15.3145 11.699 18.5447C10.7488 20.4095 10.2862 22.5407 10.0566 25.3508C9.82791 28.1504 9.82791 31.6674 9.82791 36.3145V36.3382V50.4326C9.82791 57.6522 15.6805 63.5048 22.9001 63.5048H24.906C27.1492 63.5048 28.6831 65.7705 27.85 67.8533C26.303 71.7209 30.7572 75.2174 34.1468 72.7963L42.8486 66.5807L42.8492 66.5802L43.0234 66.4562C43.0238 66.456 43.0241 66.4557 43.0245 66.4555C45.7204 64.5561 48.9328 63.5266 52.2306 63.5052C52.2311 63.5052 52.2316 63.5052 52.2322 63.5052L52.4958 63.5048H52.4964H52.5192C53.5372 63.5048 54.0673 63.5048 54.473 63.4856C63.3158 63.067 70.3901 55.9927 70.8087 47.15C70.8279 46.7442 70.8279 46.2674 70.8279 45.3537V45.3343V36.3382Z",
    stroke: "url(#paint1_linear_5_2856)",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5_2856)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9957 24.9147C45.7851 23.1452 50.29 21.472 54.1803 25.4393C63.4153 34.8571 47.5782 53.0048 40.3279 53.0048C33.0777 53.0048 17.2404 34.8571 26.4754 25.4393C30.3657 21.4721 34.8706 23.1453 37.66 24.9147C39.2362 25.9145 41.4195 25.9145 42.9957 24.9147Z",
    fill: "url(#paint2_linear_5_2856)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5_2856",
    x: -14.6721,
    y: -15.3285,
    width: 110,
    height: 113.426,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5_2856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5_2856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5_2856",
    x: 20.4054,
    y: 19.749,
    width: 46.3567,
    height: 43.0233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.25583,
    dy: 3.25583
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25583
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.466667 0 0 0 0 0.627451 0 0 0 0 0.992157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5_2856"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5_2856",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_2856",
    x1: 67.0003,
    y1: 0.328506,
    x2: 67.0003,
    y2: 41.6722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#789EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D68FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_2856",
    x1: 10.3279,
    y1: 9.67149,
    x2: 73.6801,
    y2: 69.5456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_2856",
    x1: 40.6086,
    y1: 59.3961,
    x2: 81.871,
    y2: 14.4546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like-icon.3ed0236485fb82e00511e8db8d6e37c2.svg";
export { ForwardRef as ReactComponent };